import { render } from "./VehicleDetailsComponent.vue?vue&type=template&id=77e3eca7&ts=true"
import script from "./VehicleDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleDetailsComponent.vue?vue&type=script&lang=ts"

import "./VehicleDetailsComponent.vue?vue&type=style&index=0&id=77e3eca7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__